import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface State {
  rateTypes: SelectOption[]
  selectedRateType?: SelectOption
  meta: { isLoading: boolean }
}

const initialState: State = {
  rateTypes: [],
  meta: { isLoading: false },
}

export const slice = createSlice({
  name: 'rateType',
  initialState,
  reducers: {
    fetchRateTypeStart(state) {
      state.meta.isLoading = true
    },
    fetchRateTypeSuccess(state, action: PayloadAction<SelectOption[]>) {
      state.rateTypes = action.payload
      state.meta.isLoading = false

      if (!state.selectedRateType) {
        state.selectedRateType = action.payload[0]
      }
    },
    fetchRateTypeFailed(state) {
      state.meta.isLoading = false
    },
    selectRateType(state, action: PayloadAction<SelectOption>) {
      state.selectedRateType = action.payload
    },
  },
})

export default slice.reducer
